export const environment = {
	authRoot: "https://auth.skills-tale.com",
	gameApp: "https://game.skills-tale.com"
};